import styled from 'styled-components';
import { buttoBaseStyle } from '@screens/lp-default/styles';
import { Swiper } from 'swiper/react';

export const EcosystemContainer = styled.div`
  background: ${({ theme }) => theme.elsie.colors.canvas.accent};
  font-family: NunitoSans, Verdana, Arial, sans-serif;
  height: auto;
`;

export const EcosystemBannerWrapper = styled.section`
  height: 360px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const EcosystemBanner = styled.img`
  height: 100%;
  object-fit: cover;
  width: 100%;

  @media only screen and (min-width: 1320px) {
    object-position: center 20%;
  }
`;

export const EcosystemContent = styled.div`
  padding-top: ${({ theme }) => theme.elsie.dimension[40]};
  padding-right: ${({ theme }) => theme.elsie.dimension[0]};
  padding-bottom: ${({ theme }) => theme.elsie.dimension[64]};
  padding-left: ${({ theme }) => theme.elsie.dimension[64]};
`;

export const EcosystemContentHeader = styled.section`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ theme }) => theme.elsie.dimension[16]};
  padding-left: ${({ theme }) => theme.elsie.dimension[0]};
  padding-right: ${({ theme }) => theme.elsie.dimension[64]};
  padding-top: ${({ theme }) => theme.elsie.dimension[16]};
`;

export const EcosystemContentNavigation = styled.div`
  display: flex;
  gap: 4px;
`;

export const EcosystemCardsWrapper = styled.section``;

export const EcosystemBannerTitle = styled.h2`
  bottom: 40px;
  color: ${({ theme }) => theme.elsie.colors.content.onInteractive.accent};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  font-size: ${({ theme }) => theme.elsie.fontSize['2xl']};
  left: 64px;
  letter-spacing: 0.32px;
  line-height: ${({ theme }) => theme.elsie.lineHeight.sm};
  margin: 0;
  position: absolute;
  vertical-align: middle;
  width: 90%;
`;

export const EcosystemContentTitle = styled.h4`
  color: ${({ theme }) => theme.elsie.colors.content.soft};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  font-size: ${({ theme }) => theme.elsie.fontSize['3xs']};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  text-transform: uppercase;
  vertical-align: middle;
`;

export const ArrowButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 7px 6px;
`;

export const EcosystemCard = styled.div`
  background-color: ${({ theme }) => theme.elsie.colors.surface.faint.default};
  border-radius: ${({ theme }) => theme.elsie.borderRadius.lg};
  cursor: pointer;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 50px auto 32px;
  gap: ${({ theme }) => theme.elsie.dimension[16]};
  padding: ${({ theme }) => theme.elsie.dimension[40]} ${({ theme }) => theme.elsie.dimension[20]};
  min-height: 276px;

  @media screen and (min-width: 1280px) {
    min-height: 200px;
  }
`;

export const StyledSwiper = styled(Swiper)`
  padding-right: ${({ theme }) => theme.elsie.dimension[64]};
`;

export const EcosystemCardImage = styled.div`
  align-content: center;
`;

export const EcosystemCardDescription = styled.p`
  color: ${({ theme }) => theme.elsie.colors.content.soft};
  font-size: ${({ theme }) => theme.elsie.fontSize.xs};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  margin: ${({ theme }) => theme.elsie.dimension.none};
`;

export const EcosystemCardButton = styled.button`
  ${buttoBaseStyle};
  background-color: transparent;
  border: ${({ theme }) => theme.elsie.borderWidth.sm} solid ${({ theme }) => theme.elsie.colors.border.subtle};
  border-radius: ${({ theme }) => theme.elsie.borderRadius.md};
  color: ${({ theme }) => theme.elsie.colors.content.onInteractive.soft};
  display: flex;
  gap: 8px;
  font-size: ${({ theme }) => theme.elsie.fontSize['2xs']};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  max-width: 95px;
  box-sizing: border-box;
  padding: 7.5px ${({ theme }) => theme.elsie.dimension[12]};
  vertical-align: middle;

  &:hover {
    background-color: ${({ theme }) => theme.elsie.colors.surface.faint.hovered};
  }
`;
